import { useLayoutEffect, useRef, type RefObject } from 'react';
import { resultsListScrollerOf, scrollParentOf } from '../../shared/results_page/scroll_parent.js';
import type { ExplorerState } from './explorer_state.js';

/**
 * A lista NOVA nasce no topo (#3715): trocar de perna (`outbound_chosen`,
 * `go_to_leg`, o avanço do multi em `fares_picked`) ou re-buscar a mesma perna
 * (o `seq` dela avança) troca a lista inteira no MESMO `.fex-results`, que não
 * remonta — sem isto a lista nova herdava o `scrollTop` da anterior, com título,
 * fila de trechos e as primeiras opções fora de vista.
 *
 * O rolo muda com a largura: a partir de `wide` é o `<main>` do `ResultsLayout`
 * (`listScroll="own"`, #4587), dentro do `.fex-results`; abaixo, a casca
 * (`.fex-takeover`) ou a página do host — esse só volta ao topo quando o começo
 * da lista já saiu por cima dele. O `.fex-results` também volta (ele rola o
 * estágio de tarifas). Layout effect para reposicionar
 * antes da pintura. A paginação (outra página na mesma perna) e o degelo do
 * checkout (`useResumeSeq`) não mexem em perna nem `seq`, então preservam o lugar.
 */
export function useListScrollReset(state: ExplorerState): RefObject<HTMLDivElement | null> {
  const ref = useRef<HTMLDivElement>(null);
  const key = `${String(state.activeLeg)}:${String(state.seqs[state.activeLeg] ?? 0)}`;
  const lastKey = useRef(key);
  useLayoutEffect(() => {
    const el = ref.current;
    if (key === lastKey.current || !el) return;
    lastKey.current = key;
    el.scrollTop = 0;
    const list = resultsListScrollerOf(el);
    if (list) list.scrollTop = 0;
    const host = scrollParentOf(el);
    const hostTop = host ? host.getBoundingClientRect().top : 0;
    if (el.getBoundingClientRect().top >= hostTop) return;
    if (host) host.scrollTop = 0;
    else window.scrollTo(0, 0);
  }, [key]);
  return ref;
}
